<template>
  <apex-chart
    type="bar"
    :height="height"
    :options="options"
    :series="series"
    class="chart-age"
  />
</template>

<script>
// Import node packages
import ApexChart from 'vue-apexcharts'
import merge from 'lodash/merge'

// Import default configuration option for chart
import apexChartBaseOptions from '@/json/apexChartBaseOptions.js'

// Export the SFC
export default {
  // Name of the component
  name: "AgeSplit",

  // Register the components
  components: {
    ApexChart
  },

  // Accept incoming data from parent
  props: {
    data: {
      type: Array,
      required: true
    },

    height: {
      type: [String, Number],
      required: true,
    },

    influencersCount: {
      type: Number,
      required: true
    }
  },

  // Define readonly computable properties
  computed: {
    /**
     * Get the series data for chart
     *
     * @returns {Array}
     */
    series() {
      // Get the total sum of items
      const total = this.data.reduce((acc, i) => acc + i.influencers_count, 0)

      return [
        {
          name: "Value",
          color: "#EB4D4B",
          data: [
            ...this.data.map((item) => ({
              x: item.name,
              y: (item.influencers_count / this.influencersCount) * 100,
            })).sort((a, b) => {
              return Number(a.x.split("-")[0]) - Number(b.x.split("-")[0])
            }),
            {
              x: "Unknown",
              y: ((this.influencersCount - total) / this.influencersCount) * 100,
            }
          ],
        },
      ]
    },

    /**
     * Get chart's configuration options object
     *
     * @returns {Object}
     */
    options() {
      return merge(apexChartBaseOptions(), {
        chart: {
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: 5,
        },
        yaxis: {
          type: "numeric",
          labels: {
            formatter: (val) => numeral.fPercent(val),
          },
        },
        plotOptions: {
          bar: {
            barHeight: "42%",
            horizontal: false,
            columnWidth: "42%",
            borderRadius: 4,
          },
        },
        xaxis: {
          type: "category",
        },
        legend: {
          labels: {
            colors: [host.theme.color.text],
            useSeriesColors: false,
          },
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.chart-age
  .apexcharts-legend.apexcharts-align-right.apx-legend-position-top
    right 20px !important
    top 0 !important
</style>
